module.exports = __webpack_public_path__ + "img/banner-02.d8c22710.png";